import * as React from "react";

export default function Error() {
  return <>error</>;
}
